//GeneratorFlag:[NoChange]
import ext from './fa-ext.js'
export default {
	"name":"messenger",
	"ext": ext,
	"layout":{
//GeneratorFlag:[NewLayout]
	},
	'room':'room',
	'roomCreate':'ثبت room جدید',
	'roomLayout':'room',

}